export type AttributionParams = Record<string, string>;

export const ATTRIBUTION_KEYS = [
  'vol_cid',
  'vol',
  'source',
  'campaign_id',
  'creative_id',
  'site_id',
  'zone_id',
  'sub1',
  'sub2',
  'sub3',
  'click_id',
  'nsfw'
];

export function readAttribution(searchParams: URLSearchParams): AttributionParams {
  const attribution: AttributionParams = {};
  for (const key of ATTRIBUTION_KEYS) {
    const value = searchParams.get(key);
    if (value) attribution[key] = value;
  }
  return attribution;
}

export function persistAttribution(attribution: AttributionParams) {
  if (typeof window === 'undefined') return;
  if (!Object.keys(attribution).length) return;

  const payload = {
    ...attribution,
    landing_path: window.location.pathname,
    landing_url: window.location.href,
    captured_at: new Date().toISOString()
  };

  window.localStorage.setItem('vxlover_attribution', JSON.stringify(payload));
  window.sessionStorage.setItem('vxlover_attribution', JSON.stringify(payload));
}

export function trackLandingEvent(eventName: string, data: Record<string, unknown> = {}) {
  if (typeof window === 'undefined') return;
  const event = {
    event: eventName,
    path: window.location.pathname,
    timestamp: new Date().toISOString(),
    ...data
  };
  const existing = window.sessionStorage.getItem('vxlover_events');
  const events = existing ? JSON.parse(existing) as unknown[] : [];
  events.push(event);
  window.sessionStorage.setItem('vxlover_events', JSON.stringify(events.slice(-50)));
}
